import React, { useState, useEffect, useMemo } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  Image,
  pdf
} from "@react-pdf/renderer";
import { SlDrawer, SlInput} from "@shoelace-style/shoelace/dist/react";
import  whatsappSvg from '../../assets/images/whatsapp.svg'
import  gmailSvg from '../../assets/images/email-icon-maroon.svg'
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import {alphaTypes, roles} from '../../utils/constants'
import { formatDateToReadable } from "../../utils/dateFormat";
import { getPdfFontStack } from "../../utils/pdfFonts";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu4mxP.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v29/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
      fontWeight: "bold",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 60,
    paddingVertical: 80,
    fontFamily: "Roboto",
    fontSize: 10,
  },
  header: {
    display:'flex',
    flexDirection:'row',
    padding:'20pt 10pt',
    justifyContent:'space-between',
    lineHeight: "18pt",
  },
  borderedContainer: {
    borderColor: "#ffc000",
    borderWidth: 5,
    // Make sure it grows with content:
    display: "flex",
    flexDirection: "column",
  },
  title: {
    backgroundColor: "#ffc000",
    textAlign: "center",
    fontWeight: "bold",
    paddingVertical:"5pt",
    fontSize: 10,
    marginBottom: 10,
  },
  rowFlex: {
    display: "row",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  rowFlexBetween: {
    display: "row",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  section: {
    marginBottom: 10,
  },
  ro: {
    marginBottom: 10,
    lineHeight: "18pt",
    paddingHorizontal:"10pt"
  },
  text: {
    marginBottom: 4,
  },
  terms: {
    lineHeight: "18pt",
    fontSize: "8pt",
  },
  annexure: {
    border: "1pt solid #000",
    marginTop:"20pt",
    lineHeight: "20pt",
  },
  addon:{
    borderLeft:'1pt solid #000',
    borderRight:'1pt solid #000',
    borderBottom:'1pt solid #000',
    marginBottom:'10pt'
  },
  table:{
    border: "1pt solid #000",
    
  },
  thead:{
    display:'flex',
    flexDirection:'row',
    fontWeight:'bold',
    backgroundColor:"#ffc000",
    fontSize:'10pt',
    paddingLeft:'5pt',  
    paddingTop:'5pt',
    lineHeight:'18pt',
    gap:"5pt"
  },
  tbody:{
    paddingTop:'5pt'
  },
  trow:{
   display:'flex',
    flexDirection:'row',
    paddingLeft:'5pt',
    gap:'5pt'
  },
  padLeft:{
    paddingLeft:"50pt",
    paddingRight:'25pt'
  },
  totalbox:{
    border:'1pt solid #000',
    fontSize:'10pt',
    lineHeight:'18pt'
  },
  borderFont:{
    backgroundColor:"#c9c9c7",
    fontWeight:'700',
    fontSize:'10pt',
    paddingTop:'5pt'
  },
  slno:{
    width:"5%"
  },
  adtype:{
    width:'10%'

  },
  total:{
    width:'15%',
    textAlign:'center'

  },
  unit:{
    width:'10%'

  },
  nos:{
    width:'15%'

  },
  start:{
    width:'10%'
  },
  target:{
    width:'20%'

  },
  end:{
    width:'10%'
  },
  creative:{
    width:'12%'
  },
  position:{
    width:'8%'
  },
  uom:{
    width:'10%'

  }
});

// Package orders are also mirrored into internal details; use the package row alone so it isn't listed/summed twice.
const getAdUnits = (order) => (order?.ispackage ? [] : order?.formikbsubformvalues || []);

function SalesOrderFormat({order, totalAmount, gstAmount, credit}) {
  const [stateBrand, setStateBrand] = useState({})
  const [targetsList, setTargetsList] = useState([]);

  // Client/brand/location names come in the reader's own language, so the page
  // needs a font for every script it renders, not just Roboto's Latin.
  const fontFamily = useMemo(
    () => getPdfFontStack(order, stateBrand, targetsList),
    [order, stateBrand, targetsList]
  );

  const calculateGSt = (gst, value) => {
    if (gst) {
      // GST Inclusive → extract base correctly
      return Math.round(value * 100 / 118);
    }
    return value; // GST Exclusive → value is already base
  };

  const getQuantity = (campaign_type, sales_price, budget, quantity)=>{
    if(['CPD', "Magazines", "Stories"].includes(`${campaign_type}`))
       return quantity ? quantity :  Math.round(budget / sales_price)
    if(campaign_type === 'CPC'){
      return Math.round(budget / sales_price)
    }
    if(campaign_type === 'CPM'){
      return Math.round((budget * 1000) / sales_price)
    }
  }

  const getTargets = async(lang_ids,state_ids, district_ids, constituency_ids) =>{
    try {
      let res = await API({
        url:'/order/getTarget',
        method:'POST',
        responseType:'json',
        data:{
          lang_ids, 
          state_ids,
          district_ids,
          constituency_ids,
        }
      })
      if(res.code === 200){
        return res.data
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(()=>{
    const fetchStateBrand = async()=>{
      try {
        let res = await API({
          url:'/order/fetchstatebrand',
          method:'POST',
          responseType:'json',
          data:{state_id:  !alphaTypes.includes(order.new_user_type) ? order.state : ((order.state_id?.length ?  order.state_id[0] : 0) || order.formikbsubformvalues[0]?.state_ids[0] || 0), brand_id :order.brand_id}
        })
        if(res.code === 200){
          setStateBrand(res.data)
        }
      } catch (error) {
        console.error(error)
      }
    }
    fetchStateBrand()
  },[order.state, order.brand_id])
  useEffect(() => {
    const loadTargets = async () => {
  
      const results = [];
  
      for (const item of getAdUnits(order)) {
        const text = await getTargets(
          item.lang_ids,
          item.state_ids,
          item.district_ids,
          item.constituency_ids
        );
        results.push(text || "-");
      }
  
      // if package
      if (order.ispackage) {
        const pkgText = await getTargets(
          order.lang_id,
          order.state_id,
          order.district_id,
          order.constituency_id
        );
        results.push(pkgText || "-");
      }
  
      setTargetsList(results);
    };
  
    loadTargets();
  }, [order]);

  const uomLabel = (type) =>
  type === 'CPM' ? '1,000 Impressions'
  : type === 'CPC' ? 'Clicks'
  : type === 'CPD' ? 'Days'
  : type;

const displayQty = (item) => {
  const q = getQuantity(item.campaign_type, item.sales_price, item.adunit_budget, item.quantity);
  const n = item.campaign_type === 'CPM' ? q / 1000 : q;
  return Number(n).toLocaleString('en-IN');
};
  
  return (<>
  <Document>
    <Page size="A3" style={[styles.page, { fontFamily }]}>
      {/* The border box will now grow with content */}
      <View style={styles.borderedContainer}>
        <View style={styles.header}>
          <View>
            <Image style={{width:'226pt', height:'51pt'}} src="https://d20m247hrbeug2.cloudfront.net/way2news-webviews/order_logo/1764226232770.png" ></Image>
          </View>
          <View style={{width:'30%'}}>
          <Text style={{ fontWeight: "bold", fontFamily:"Roboto", fontSize: 14 }}>
            Way2news Private Limited
          </Text>
          <Text>
            1st Floor, H.No. 8-2-293, Plot No. 499, Road No. 36, Jubilee Hills,
            Hyderabad, Telangana 500033
          </Text>
            <Text>
              <Text style={{ fontWeight: "700" }}>CIN:</Text>{" "}
              U74999TG2019PTC137196{" "}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>PAN:</Text> AACCW5541P{" "}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>GST:</Text> 36AACCW5541P1ZS{" "}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>MSME No:</Text>{" "}
              UDYAM-TS-02-0008071{" "}
            </Text>
          </View>
        </View>

        <Text style={styles.title}>Sales Order</Text>

        <View style={styles.ro}>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "700" }}>No:</Text>{" "}
              {order.order_id}
            </Text>
            <Text>
              <Text style={{ fontWeight: "700" }}>Ref Ro number:</Text>{" "}
             {order.ro_no || '-'}
            </Text>
          </View>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Date:</Text> {formatDateToReadable(order.o_start_date)}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Ref Ro Date:</Text>{" "}
            {order.ro_no && order.o_start_date ? formatDateToReadable(order.o_start_date) : '-'}
            </Text>
          </View>
        </View>
        <View style={styles.ro}>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Customer Name:</Text>{" "}
              {order?.client_name || (order.company_name?.toLowerCase().includes('alpha') ? '-' : order.company_name)}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>GST No:</Text> {order.c_gst ? order.c_gst : 'Unregistered'}
            </Text>
          </View>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Address:</Text>{" "}
             {order.alpha_client_address || order.address || '-'}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>State:</Text> {stateBrand.state}
            </Text>
          </View>
        </View>
        <View style={styles.ro}>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Contact Email:</Text>{" "}
             {alphaTypes.includes(order.new_user_type) ? (order.alpha_client_email || '-') : order.c_email}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Credit Period:</Text>{credit + " Days"}
              {order.creditPeriod}
            </Text>
          </View>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Mobile:</Text>{" "}
             {order?.client_mobile || order.c_mobile}
            </Text>
          </View>
        </View>

        <Text style={{lineHeight:"18pt", paddingHorizontal:'10pt'}}><Text style={{ fontWeight: "bold" }}>Brand Name:</Text>{" "}{order?.client || (stateBrand.brand_name?.includes('alpha') ? '-' : stateBrand.brand_name)}</Text>
        <View style={styles.ro}>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Sales Person Name:</Text>{" "}
              {order.sales_name}
            </Text>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Sales Person Contact:</Text>{" "}
             {order.sales_email}
            </Text>
          </View>
          <View style={styles.rowFlexBetween}>
            <Text>
              <Text style={{ fontWeight: "bold" }}>Team:</Text>{" "}
              {(order.sales_team?.toLowerCase().includes('alpha')) ? '-' : order.sales_team}
            </Text>
            <Text>{order.sales_mobile} </Text>
          </View>
        </View>
        <View style={styles.terms}>
          <Text style={{fontSize:"10pt", paddingLeft:"10pt"}}>Particulars of advertisement request confirmed by us: </Text>
          <View style={styles.table}>
            <View style={styles.thead}>
              <Text style={styles.slno}>Sl no</Text>
              <Text style={styles.adtype}>Ad Type</Text>
              <Text style={styles.uom}>UoM</Text>
              <Text style={styles.position}>Position</Text>
              <Text style={styles.target}>Target Locations</Text>
              <Text style={styles.creative}>Creative Type</Text>
              <Text style={styles.start}>Period from</Text>
              <Text style={styles.end}> Period to</Text>
              <Text style={styles.nos}>Quantity</Text>
              <Text style={styles.unit}>Unit Price</Text>
              <Text style={styles.total}>Total in INR</Text>
            </View>
            <View style={styles.tbody}>
              <>
              {getAdUnits(order).map((item,idx)=>(
                <View style={styles.trow}> <Text style={styles.slno}>{idx+1}</Text>
                <Text style={styles.adtype}>{item.campaign_type}</Text>
                <Text style={styles.uom}>{uomLabel(item.campaign_type)}</Text>
                <Text style={styles.position}>{item.positions.join(', ')}</Text>
                <Text style={styles.target}>{targetsList[idx]}</Text>
                <Text style={styles.creative}>{item.creative_type}</Text>
                <Text style={styles.start}>{formatDateToReadable(item.date_ranges[0]?.start_date)}</Text>
                <Text style={styles.end}> {formatDateToReadable(item.date_ranges[0]?.end_date)}</Text>
                <Text style={styles.nos}>{displayQty(item)}</Text>
                <Text style={styles.unit}>{calculateGSt(order.gst, item.sales_price)}</Text>
                <Text style={styles.total}>{calculateGSt(order.gst, item.adunit_budget)}</Text></View>
              ))}
              {
                order.ispackage ?  <View style={styles.trow}> <Text style={styles.slno}>1</Text>
                <Text style={styles.adtype}>{'Packages'}</Text>
                <Text style={styles.uom}>{'Packages'}</Text>
                <Text style={styles.position}>{order.position}</Text>
                <Text style={styles.target}>{targetsList[targetsList.length - 1]}</Text>
                <Text style={styles.creative}>{order.creative_type}</Text>
                <Text style={styles.start}>{formatDateToReadable(order.o_start_date)}</Text>
                <Text style={styles.end}> {formatDateToReadable(order.o_end_date)}</Text>
                <Text style={styles.nos}>{order?.package_weeks}</Text>
                <Text style={styles.unit}>{(calculateGSt(order.gst, order.order_value) / order?.package_weeks || 1).toFixed(2)}</Text>
                <Text style={styles.total}>{calculateGSt(order.gst, order.order_value)}</Text></View> : null
              }
              </>
            </View>

          </View>
          <View style={styles.totalbox}>
            <View style={[styles.padLeft, styles.rowFlexBetween,styles.borderFont]}>
              <Text c>Total before GST</Text>
              <Text>{totalAmount}</Text>
            </View>
            <View style={[styles.padLeft, styles.rowFlexBetween,{paddingTop:'5pt'}]}>
            <Text>Add: GST @18%</Text>
            <Text>{gstAmount}</Text>
            </View>
            <View style={[styles.padLeft, styles.rowFlexBetween,styles.borderFont]}>
            <Text>Total advertisement price</Text>
            <Text>{totalAmount + gstAmount}</Text>
            </View>
            <View style={[styles.padLeft, styles.rowFlexBetween,{paddingTop:'5pt'}]}>
            <Text>Amount Received</Text>
            <Text>{order.payment_details?.amount || 0}</Text>
            </View>
            <View style={[styles.padLeft, styles.rowFlexBetween,{paddingTop:'5pt'}]}>
            <Text>Payment id :</Text>
            <Text>{order.payment_details?.cheque_no || '-'}</Text>
            </View>
            <View style={[styles.padLeft, styles.rowFlexBetween,styles.borderFont]}>
            <Text>Balance Payable</Text>
            <Text>{(totalAmount + gstAmount) - (+order.payment_details?.amount || 0)}</Text>
            </View>
            <Text style={[styles.padLeft, styles.rowFlexBetween]}>TDS deduted if any @2% will appear in balance payable, the same will be considered as received when TDS deduction certificate
            is shared by the customer on billing@way2news.com</Text>
          </View>
          {/* <View style={styles.addon}>
              <>
              <Text style={{fontWeight:"bold",textDecoration:'underline', paddingLeft:'50pt'}}>Add Ons.</Text>
              {sampleOrder.addOns?.map((item, idx)=>(
                <View style={styles.trow}> 
                <Text style={{width:"100%"}}>{idx+1}</Text>
                <Text style={styles.unit}>{item.nos}</Text>
                <Text style={styles.total}>{item.total}</Text>
                </View>
              ))}
              </>
            </View> */}
            <View style={{paddingHorizontal:'10pt', marginTop:'10pt'}}>
          <Text>
            Terms and conditions as included in the website www.way2news.com
            applies.
          </Text>
          <Text>
            All commitiments in relation to the sales order have been included
            here. Any additional services shall be charged seperatley. In case
            of any disputes/ clarification please reach out before publishing of
            the advertisement. Any disputes in relation to additional
            commitments shall be allowed.
          </Text>
          <Text>
            Sales representatives of way2news doesnot collect cash. Refer terms
            and conditions of the website for terms of the advertisements.
          </Text>
          <Text>
            All monies to be paid to company account directly and should not be
            paid to sales representatives; Way2news shall not take any
            responsibility.
          </Text>
          <Text>For any disputes react out to <Text style={{color:"red"}}>billing@way2news.com</Text></Text>
          </View>
        </View>
      </View>
      {order.ispackage ? <View style={styles.annexure}>
        <Text
          style={{
            backgroundColor: "#c9c9c7",
            textAlign: "center",
            borderBottom: "1pt solid #000",
          }}
        >
          Annexure: A
        </Text>
        <View style={styles.rowFlexBetween}>
          <Text>Package details : </Text>
          <View>
            <Text>No of advertisement: {order.package_weeks}</Text>
            <Text>
              The amounts received is non refundable and package needs to be
              consumed within the time bracket.{" "}
            </Text>
          </View>
        </View>
      </View> : null}
    </Page>
  </Document>
  </>)
} 

function OrderPdf(props) {
  const [sendEmail, setSendEmail] = useState(true)
  const [sendWhatsApp, setSendWhatsapp] = useState(true)
  const [totalBeforeGST, setTotalBeforeGST] = useState(0)
  const [gstAmount, setGstAmount] = useState(0)
  const [creditPeriod, setCreditPrediod] = useState(30)
  const isFinance = localStorage.getItem('role') === roles.financer
  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };
  
  const handleClose = () => {
    props.setShow(false);
    props.setOrderData({});
  };
  const uploadPdf =  async() =>{
    try {
      const blob = await pdf(<SalesOrderFormat order={props.orderData} totalAmount={totalBeforeGST} gstAmount={gstAmount} credit={creditPeriod}/>).toBlob();

    // 2️⃣ Create FormData to send binary file
    const formData = new FormData();
    formData.append('files', blob, 'order.pdf');
      let res = await API({
          url:"/upload/file-upload",
          method:'POST',
          data:formData,
        headers: { "Content-Type": "multipart/form-data" },

      })
      if(res.code === 200){
        return res.data
      } 
    } catch (error) {
      console.error("Upload Failed", error)
      throw new Error("Upload Failed")
    }
  }
  const sendMessages = async() =>{
    if(!sendEmail && !sendWhatsApp){
      Toast('error','Select at least one channel to send')
      return
    }
    try {
    let order_url = await uploadPdf()
    if(!order_url){
      Toast('error','Failed to upload order pdf')
      return
    }
    let res = await API({
    url:'/order/sendMessages',
    method:'POST',
    responseType:'json',
    data:{
      order_id:props.orderData?.order_id,
      order_url,
      isEmail:sendEmail,
      isWhatsapp:sendWhatsApp
    }
    })
    console.log(res, "Send Messages Response")
    if(res.code === 200){
      Toast('success','Messages Send Successfully!')
      handleClose()
    }
    else{
      Toast('error',res?.message || 'Failed to send messages')
    }
  } catch (error) {
    Toast('error','Failed to send messages')
    console.error(error, "Error sending messages")
  }
  }

  useEffect(() => {
    const subData = getAdUnits(props.orderData);
    let totalAdBudget = 0;
  
    for (const data of subData) {
      totalAdBudget += Number(data?.adunit_budget) || 0;
    }
  
    if (props.orderData?.ispackage && props.orderData?.order_value) {
      totalAdBudget += Number(props.orderData.order_value) || 0;
    }
  
    let baseAmount = 0;
    let gstAmount = 0;
  
    if (props.orderData?.gst === true) {
      // GST INCLUSIVE → Extract base correctly
      baseAmount = Math.round(totalAdBudget * 100 / 118);
      gstAmount = totalAdBudget - baseAmount;
    } else {
      // GST EXCLUSIVE
      baseAmount = totalAdBudget;
      gstAmount = Math.round(totalAdBudget * 0.18);
    }
  
    setTotalBeforeGST(baseAmount);
    setGstAmount(gstAmount);
  }, [props.orderData]);
  
  return (
    <>
     <SlDrawer label="Order Preview"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": `${window.innerWidth <= 767 ? "100%" : '50%'}` }}>
      <PDFViewer
        style={{ width: "100%", height: "800px", border: "1px solid black" }}
      >
        <SalesOrderFormat order={props.orderData} totalAmount={totalBeforeGST} gstAmount={gstAmount} credit={creditPeriod}/>
      </PDFViewer>
      {isFinance && (
        <div className="flex flex-wrap items-center justify-end gap-4 my-3">
          <SlInput type="number" label="Credit Period" value={creditPeriod} placeholder="Enter Credit Period" onSlInput={(e) => setCreditPrediod(e.target.value)}/>

          <div className="flex items-center gap-3">
            {/* Email — optional */}
            <label className="group relative block cursor-pointer w-10">
              <input
                type="checkbox"
                name="placements[]"
                value="email"
                checked={sendEmail}
                onChange={() => setSendEmail((prev) => !prev)}
                className="peer sr-only"
                aria-label="Email"
              />
              <div className="overflow-hidden rounded-md border bg-white transition
                              peer-focus-visible:outline peer-focus-visible:outline-2
                              peer-focus-visible:outline-offset-2 peer-focus-visible:outline-blue-500
                              peer-checked:border-blue-600 peer-checked:ring-2 peer-checked:ring-blue-500">
                <div className="aspect-square flex items-center justify-center">
                  <img
                    src={gmailSvg}
                    alt="Email"
                    className="h-10 w-10 object-contain transition-transform duration-200 group-hover:scale-105"
                  />
                </div>
              </div>
            </label>

            {/* WhatsApp — optional */}
            <label className="group relative block cursor-pointer w-10">
              <input
                type="checkbox"
                name="placements[]"
                value="whatsapp"
                checked={sendWhatsApp}
                onChange={() => setSendWhatsapp((prev) => !prev)}
                className="peer sr-only"
                aria-label="Whatsapp"
              />
              <div className="overflow-hidden rounded-md border bg-white transition
                              peer-focus-visible:outline peer-focus-visible:outline-2
                              peer-focus-visible:outline-offset-2 peer-focus-visible:outline-blue-500
                              peer-checked:border-blue-600 peer-checked:ring-2 peer-checked:ring-blue-500">
                <div className="aspect-square flex items-center justify-center">
                  <img
                    src={whatsappSvg}
                    alt="Whatsapp"
                    className="h-10 w-10 object-contain transition-transform duration-200 group-hover:scale-105"
                  />
                </div>
              </div>
            </label>
          </div>

          <button
            type="button"
            onClick={sendMessages}
            className="inline-flex items-center justify-center rounded-md bg-green-600 px-4 py-2
                       text-white text-sm hover:bg-green-700 focus-visible:outline focus-visible:outline-2
                       focus-visible:outline-offset-2 focus-visible:outline-green-600"
          >
            Send
          </button>
        </div>
      )}

      </SlDrawer>
    </>
  );
}
export default OrderPdf;
